<!-- Header -->
<div>
	<div mat-dialog-title
		style="margin-bottom: 0"
		role="heading"
		translate>
		Student Filters
	</div>
	<div style="margin: 10px">
		<div [ngStyle]="{'background-color': currentQuery.queryChanged ? 'rgb(255, 255, 153)' : 'inherit'}"
			style="width: 201px; max-width: fit-content">
			<tyl-form-field label="Current Filter"
				[preventCollapse]="true"
				[hint]="currentQuery.queryChanged ? 'Modified' : ''">
				<mat-select [(ngModel)]="currentQuery"
					id="currentFilterField"
					name="Current Filter">
					<mat-option [value]="null">
						Reset
					</mat-option>
					<mat-option *ngFor="let recentFilter of information.recentStudentFilters"
						[value]="recentFilter">
						{{recentFilter.QueryName}}
					</mat-option>
				</mat-select>
			</tyl-form-field>
		</div>
	</div>
	<div style="margin: 10px">
		<b>Conditions</b> (Rows with the same group letter are joined with AND. Rows with different group letters are joined with OR.)
	</div>
</div>

<!-- Body -->
<mat-dialog-content>

	<!-- Table -->
	<data-query-filter-table [(filters)]="allFilters"
		[forStudentSearch]="true"></data-query-filter-table>

	<!-- SQL Translation -->
	<ng-container *ngIf="generalPreferences && generalPreferences.ShowSQLTranslation">
		<div style="font-weight: bold; margin-top:10px;">
			SQL Translation
		</div>
		<div>
			{{filterTranslation}}
		</div>
	</ng-container>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left">
		<data-query-queries-button [forFilters]="true"></data-query-queries-button>
		<tyl-button image="add.png"
			label="Add Filter"
			(clickEvent)="addFilter()"></tyl-button>
		<tyl-button image="add.png"
			label="Add Roster Filter"
			(clickEvent)="addRosterFilter()"></tyl-button>
	</div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button image="Save.png"
			label="Apply"
			(clickEvent)="apply()"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>
